var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.5C4.9 15.5 4.5 15.1 4.5 14.5V1.5C4.5 0.9 4.9 0.5 5.5 0.5H12.5C13.1 0.5 13.5 0.9 13.5 1.5V14.5C13.5 15.1 13.1 15.5 12.5 15.5H5.5Z",
    fill: "#B0C1D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C12.8 1 13 1.2 13 1.5V14.5C13 14.8 12.8 15 12.5 15H5.5C5.2 15 5 14.8 5 14.5V1.5C5 1.2 5.2 1 5.5 1H12.5ZM12.5 0H5.5C4.7 0 4 0.7 4 1.5V14.5C4 15.3 4.7 16 5.5 16H12.5C13.3 16 14 15.3 14 14.5V1.5C14 0.7 13.3 0 12.5 0Z",
    fill: "#66798F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5H13.5V13.5H4.5V2.5Z",
    fill: "#F2FAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3V13H5V3H13ZM14 2H4V14H14V2ZM8 14H10V15H8V14Z",
    fill: "#66798F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.761C1.35 7.025 1.581 7.483 1.581 8.002C1.581 8.522 1.35 8.979 1 9.243",
    stroke: "#4E7AB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34 6.143C2.839 6.559 3.163 7.237 3.163 8.002C3.163 8.772 2.835 9.452 2.332 9.867",
    stroke: "#4E7AB5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H8V7H9V8H10V9H11V8H12V9H11V10H10V9H9V8H8V7H6V5Z",
    fill: "#5E9C76"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H6V11H8V9Z",
    fill: "#5E9C76"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H10V7H12V5Z",
    fill: "#5E9C76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H12V11H11V10Z",
    fill: "#5E9C76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H10V11H9V10Z",
    fill: "#5E9C76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrphone);
export default __webpack_public_path__ + "static/media/qrphone.dfb58bdf57a11073c3098bed48b7c5be.svg";
export { ForwardRef as ReactComponent };